module.exports = __webpack_public_path__ + "static/PFB_INTRO_IMAGES_02-f38e0bd50215cdad8856909e5066c213.jpg";